import { useState } from 'react'
import { fetcher, AdminSeasonChallengesEndpoints, IUseSeasonChallenges } from '@olagg/api-hooks'
import { AdminSeasonChallenge } from '@olagg/db-types'

export interface UseSeasonChallengesReturn {
  loading: boolean
  getChallenges: (params: IUseSeasonChallenges) => Promise<{ challenges: AdminSeasonChallenge[], totalPages: number }>
  getChallenge: (id: string) => Promise<AdminSeasonChallenge>
  createChallenge: (data: any) => Promise<AdminSeasonChallenge>
  updateChallenge: (id: string, data: any) => Promise<AdminSeasonChallenge>
  deleteChallenge: (id: string) => Promise<void>
}

const useSeasonChallenges = (): UseSeasonChallengesReturn => {
  const [loading, setLoading] = useState(false)

  const getChallenges = async (params: IUseSeasonChallenges) => {
    setLoading(true)
    try {
      const response = await fetcher(AdminSeasonChallengesEndpoints.all(params))
      return response
    } catch (error) {
      console.error('Error fetching season challenges:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const getChallenge = async (id: string): Promise<AdminSeasonChallenge> => {
    setLoading(true)
    try {
      const response = await fetcher(AdminSeasonChallengesEndpoints.find(id))
      return response
    } catch (error) {
      console.error('Error fetching season challenge:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const createChallenge = async (data: any): Promise<AdminSeasonChallenge> => {
    setLoading(true)
    try {
      const response = await fetcher(AdminSeasonChallengesEndpoints.create(data))
      return response
    } catch (error) {
      console.error('Error creating season challenge:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const updateChallenge = async (id: string, data: any): Promise<AdminSeasonChallenge> => {
    setLoading(true)
    try {
      const response = await fetcher(AdminSeasonChallengesEndpoints.update(id, data))
      return response
    } catch (error) {
      console.error('Error updating season challenge:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  const deleteChallenge = async (id: string): Promise<void> => {
    setLoading(true)
    try {
      await fetcher(AdminSeasonChallengesEndpoints.delete(id))
    } catch (error) {
      console.error('Error deleting season challenge:', error)
      throw error
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    getChallenges,
    getChallenge,
    createChallenge,
    updateChallenge,
    deleteChallenge
  }
}

export default useSeasonChallenges
